import React from 'react';
import { Link } from 'react-router-dom';
import NavigationMenu from '../navigation/NavigationMenu';
import MobileNavigation from '../navigation/MobileNavigation';
import UserMenu from '../auth/UserMenu';
import { useAuth } from '../../hooks/useAuth';
import Logo from './Logo';

const Header = () => {
  const { user } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 bg-background-secondary border-b border-gray-800 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Logo 
            className="flex-shrink-0" 
            logoUrl="/images/Database_Small_Logo.png"
          />
          <NavigationMenu />
          {user ? (
            <UserMenu />
          ) : (
            <button
              onClick={() => window.dispatchEvent(new Event('open-auth'))}
              className="text-content-secondary hover:text-content-primary text-sm font-medium px-3 py-2 rounded-md transition-colors"
            >
              Sign In
            </button>
          )}
          <MobileNavigation />
        </div>
      </div>
    </header>
  );
};

export default Header;